import { PayloadAction } from "@reduxjs/toolkit";
import { editorInterface } from "../slice/editor";
import { decodedBase64 } from "../../@types/data";

/**
 * Updates the base64Signature property of the editor's state with the payload from the action.
 *
 * @param action
 * @param {editorInterface} state - The current state of the editor*/
export const setBase64Signature = (
  state: editorInterface,
  action: PayloadAction<{ base64: string | null, color: string | null, layout: number, position: { x: number, y: number }, size: { width: number, height: number }, angle: number }>
) => {
  const { base64, layout, position, color, size, angle } = action.payload;

  if (!action.payload.base64) return;

  const existingSignatureIndex = state.signatures.findIndex(
    (signature) => signature.base64 === base64
  );
  const newPosition = {
    x: Math.max(0, position.x),
    y: Math.max(0, position.y),
  };

  if (existingSignatureIndex !== -1) {
    state.signatures = state.signatures.map((signature, index) => {
      if (index === existingSignatureIndex) {
        return {
          ...signature,
          layout: Array.from(new Set([...signature.layout, layout])),
          color,
          position: newPosition,
          size,
          angle,
        };
      }
      return signature;
    });
  } else {
    state.signatures = [
      ...state.signatures,
      {
        layout: [layout],
        base64,
        color,
        position: newPosition,
        size,
        angle,
      }
    ];
  }
};

/**
 * Removes a specific signature and its associated layout value from the editor's state.
 *
 * This reducer function identifies a signature in the state based on its base64 value.
 * If the matching signature contains the specified layout value, that layout is removed.
 * If the signature no longer has any associated layout values after the removal, it is also removed from the state.
 *
 * @param state - The current state of the editor, containing the signatures and their layouts.
 * @param action - An action object containing the payload with the following properties:
 *   @param action.payload.base64 - The base64-encoded string used to identify the signature to be modified.
 *   @param action.payload.layout - The layout value to be removed from the specified signature.
 */
export const removeSignatureFromLayout = (
  state: editorInterface,
  action: PayloadAction<{
    base64: string;
    layout: number;
  }>
) => {
  const { base64, layout } = action.payload;

  state.signatures = state.signatures.map( ( signature ) => {
    if ( signature.base64 === base64 && Array.isArray( signature.layout ) ) {
      const updatedLayouts = signature.layout.filter( ( l ) => l !== layout );
        return {
          ...signature,
          layout: updatedLayouts,
        };
    }
    return signature;
  } )
}

/**
 * Removes a base64 signature from the editor's state.
 *
 * @param state - The current state of the editor.
 * @param action - The action payload containing the base64 signature to remove.
 */
export const removeBase64Signature = (state: editorInterface, action: PayloadAction<{ base64: string | null }>) => {
  state.signatures = state.signatures.filter(signature => signature.base64 !== action.payload.base64);
};

/**
 * A Redux reducer function that decodes a Base64 string and updates the state with the decoded image data.
 */
export const decodeFromBase64 = (state: editorInterface, action: PayloadAction<decodedBase64>) => {
  const { cardIndex, src} = action.payload
  if(JSON.stringify(src) === '""'){ return; }
  else{
    try {
      state.currentData[cardIndex].dataImgCard.base64Image = src;
    } catch (error) {
      console.error("Erreur de décodage Base64 : ", error);
    }
  }
};

/**
 * Updates the image data of a specific card within the application's state.
 */
export const updateImageData = (state, action) => {

    state.toolbarDisplay = {
      value: "image",
      index: action.payload.index,
    };

}

